import styled from 'styled-components';

interface LabelProps {
  hasError: string
}

export const Label = styled.label<LabelProps>`
  color: ${({ hasError, theme }) => hasError === 'true' ? theme.colors.secondary : theme.colors.main};
`;
